import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import HomeIcon from '@material-ui/icons/Home'
import LocalAtmIcon from '@material-ui/icons/LocalAtm'
import PeopleIcon from '@material-ui/icons/People'
import Payments from './Payment/Payment'
import Birthday from './birthday/Birthday'
import Categories from './categories/Categories'
import Dashboard from './dashboard/Dashboard'
import People from './people/People'
import Schedule from './schedule/Schedule'
import Transactions from './transactions/Transactions'
import Transfers from './transfers/Transfers'

import Patrimony from './patrimony/Patrimony'

const PAGES = [
  {
    title: 'Painel',
    path: '/',
    icon: HomeIcon,
    component: Dashboard,
  },
  {
    title: 'Membros',
    path: '/membros',
    icon: PeopleIcon,
    component: People,
    role: 'people',
  },
  {
    title: 'Lançamentos',
    path: '/lancamentos',
    icon: AttachMoneyIcon,
    component: Transactions,
    role: 'transactions',
  },
  {
    title: 'Transferências',
    path: '/transferencias',
    icon: LocalAtmIcon,
    component: Transfers,
    role: 'transactions',
  },
  {
    title: 'Categorias',
    path: '/categorias',
    icon: LocalAtmIcon,
    component: Categories,
    role: 'transactions',
  },
  {
    title: 'Agenda',
    path: '/agenda',
    icon: LocalAtmIcon,
    component: Schedule,
    role: 'transactions',
  },
  {
    title: 'Aniversariantes',
    path: '/birthday',
    icon: LocalAtmIcon,
    component: Birthday,
    role: 'transactions',
  },
  {
    title: 'Pagamentos',
    path: '/payment',
    icon: AddShoppingCartIcon,
    component: Payments,
    role: 'transactions',
  },
  {
    title: 'Patrimônio',
    path: '/patrimony',
    icon: LocalAtmIcon,
    component: Patrimony,
    role: 'transactions',
  },
]

export default PAGES
